import { baseApi } from "../baseApi";

export const globalapi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDoctypeCount: builder.query({
      query: (doctype) => ({
        url: `/api/method/frappe.client.get_count`,
        params: { doctype },
      }),
    }),
    getDoctypePrint: builder.query({
      query: (params) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.react_api.generate_pdf`,
        params,
        headers: {
          Accept: "application/pdf",
        },
        responseHandler: (response) => response.blob(),
      }),
    }),
    getDoctypePrintType: builder.query({
      query: (params) => ({
        url: `/api/resource/Print Format`,
        params,
      }),
    }),
    getDoctypeData: builder.query({
      query: (params) => ({
        url: `/api/method/frappe.desk.form.load.getdoc`,
        params,
      }),
    }),
    postDoctypeListApi: builder.mutation({
      query: (body) => ({
        url: `/api/method/frappe.desk.reportview.get`,
        method: 'POST',
        body
      }),
    }),
    postUploadFile: builder.mutation({
      query: (body) => ({
        url: `/api/method/upload_file`,
        method: "POST",
        body,
      }),
    }),
    postSaveDoc: builder.mutation({
      query: (body) => ({
        url: `/api/method/frappe.desk.form.save.savedocs`,
        method: "POST",
        body,
      }),
    }),
    getDeleteUploadFile: builder.mutation({
      query: ({ fid, dt, dn }) => ({
        url: `/api/method/frappe.desk.form.utils.remove_attach`,
        method: "DELETE",
        body: { fid, dt, dn },
      }),
    }),

    getDocFieldsWithVisibility: builder.query({
      query: (doc) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.api.get_doc_fields_with_visibility`,
        params: { doc },
      }),
    }),
    // getDocOfAttachment: builder.query({
    //   query: (doc) => ({
    //     url: `/api/method/stackerbee_mobile_wms.wms.react_api.get_attachments_for_doc`,
    //     params: doc,
    //   }),
    // }),
    getDocOfAttachment: builder.query({
      query: ({ doctype, docname }) => {
        const filters = encodeURIComponent(
          JSON.stringify([
            ["File", "attached_to_doctype", "=", doctype],
            ["File", "attached_to_name", "=", docname],
          ])
        );

        const fields = encodeURIComponent(
          JSON.stringify([
            "file_name",
            "file_type",
            "file_size",
            "file_url",
            "attached_to_doctype",
            "attached_to_name",
            "name",           // add if you need ID for delete
            "creation"        // add if you want date info
          ])
        );

        return {
          url: `/api/resource/File?filters=${filters}&fields=${fields}`,
          method: "GET",
        };
      },
    }),
    deleteDoc: builder.mutation({
      query: ({ doctype, name }) => ({
        url: `/api/method/frappe.client.delete`,
        method: "DELETE",
        params: { doctype, name },
      }),
    }),

  }),
});

export const {
  useGetDoctypeCountQuery,
  useGetDoctypePrintQuery,
  useGetDoctypeDataQuery,
  usePostUploadFileMutation,
  useGetDocOfAttachmentQuery,
  useGetDoctypePrintTypeQuery,
  useGetDeleteUploadFileMutation,
  useGetDocFieldsWithVisibilityQuery,
  useDeleteDocMutation,
  usePostSaveDocMutation,
  usePostDoctypeListApiMutation
} = globalapi;
